// extracted by mini-css-extract-plugin
module.exports = {"text":"TextView_text__S0UQW"};